<template>
  <div class="mt-4">
    <app-tile-group
      v-model="templateType"
      class="template-type-group"
      tile-layout="vertical"
      :options="templateTypeOptions"
      :aria-label="$t('project.checklist.dialogs.SaveChecklistDialog.step1Title')"
      data-locator="template-type-group"
    />
  </div>
</template>

<script>
  import { TEMPLATE_TYPE_OPTIONS } from '@/common/utils/templateTypes.ts'

  export default {
    name: 'SaveChecklistTemplateType',
    props: {
      defaultTemplateType: {
        required: true,
        validator: (value) => {
          return value === null || typeof value === 'string'
        },
      },
    },
    data () {
      return {
        TEMPLATE_TYPE_OPTIONS,
        templateType: this.defaultTemplateType,
      }
    },
    computed: {
      templateTypeOptions () {
        return [
          {
            value: TEMPLATE_TYPE_OPTIONS.NEW,
            label: this.$t('project.checklist.dialogs.SaveChecklistDialog.createNewModel'),
            caption: this.$t('project.checklist.dialogs.SaveChecklistDialog.createNewModelSubtitle'),
            icon: 'wand_stars',
          },
          {
            value: TEMPLATE_TYPE_OPTIONS.UPDATE,
            label: this.$t('project.checklist.dialogs.SaveChecklistDialog.updateExistingModel'),
            caption: this.$t('project.checklist.dialogs.SaveChecklistDialog.updateExistingModelSubtitle'),
            icon: 'cached',
          },
        ]
      },
    },
    watch: {
      templateType (value) {
        this.$emit('change-template-type', value)
      },
    },
  }
</script>
